module.exports = __webpack_public_path__ + "img/top_option-6.55965eaf.png";